module.exports = __webpack_public_path__ + "static/media/msg-sucesso.5dfd4143.svg";